module.exports = __webpack_public_path__ + "img/team-11-modal.3b068c2b.jpg";